/*
  Global Filters
*/
import Vue from 'vue'

Vue.prototype.$format = function(n, x) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

Vue.filter('pct', function (value, decimals) {
    if (!value) value = 0
    if (!decimals) decimals = 0
  
    value = value * 100
    return parseFloat(value).toFixed(decimals)+"%"
  })

  Vue.filter('usd', function(value, decimals) {
    if (!value) value = 0
    if (!decimals) decimals = 0

    return '$'+(parseFloat(value)).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  })
  
  Vue.filter('round', function (value, decimals) {
    if (!value) value = 0
    if (!decimals) decimals = 0
  
    return value.toFixed(decimals)
  })

  Vue.filter('usDate', function(value){
    if(!value) return '';
    return value.toDate().toLocaleDateString()
  })

export default {}